import { render, staticRenderFns } from "./EditPdfLeft.vue?vue&type=template&id=52735e6f&"
import script from "./EditPdfLeft.vue?vue&type=script&lang=js&"
export * from "./EditPdfLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports